<template>
  <TableGradient
      icon-name="edit"
      :title="$t('reportEditable.listagem.titulo_pagina')"
      :text-empty="$t('reportEditable.listagem.table.empty')"
      :fields="fields"
      :fields-filter="filter"
      :items="reportEditables"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('reportEditable/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.report_editable.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('reportEditable.listagem.table.editar') }}
      </router-link>
    </template>    
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      reportEditables: 'reportEditable/all',
      paginator: 'reportEditable/pagination',
      reportEditableIsLoading: 'reportEditable/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.reportEditableIsLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'vns', label: this.$t('reportEditable.listagem.table.nome'), sortable: true, keyFullName: 'vns.name'},
        {key: 'company_name', label: this.$t('reportEditable.listagem.table.empresa'), sortable: true},
        {key: 'report_editable', label: this.$t('reportEditable.listagem.table.resultado_editavel')},
        {key: 'id', label: this.$t('reportEditable.listagem.table.editar')}
      ],
      filter: [
        {key: 'vns', label: this.$t('reportEditable.listagem.table.nome')},
        {key: 'company_name', label: this.$t('reportEditable.listagem.table.empresa')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'reportEditable/listAll'
    ])
  },
  mounted() {
    this['reportEditable/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
